import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { FormInput, Margin, Text } from 'shared/components'
import { EditableFormPanel } from 'routes/shared/components'

import { getOptionLabel, getOptionValue } from './helpers'

import * as styles from './styles'

const AddMemberInvoiceFormComponent = ({
  form,
  header,
  onSubmitRequest,
  loadBankAccounts,
  setupAmountValidation,
}) => {
  // Call setupAmountValidation when component mounts
  useEffect(() => {
    if (setupAmountValidation) {
      setupAmountValidation();
    }
  }, [setupAmountValidation]);

  return (
    <EditableFormPanel header={header} form={form} onSubmit={onSubmitRequest}>
      {(editable) => {
        const disabled = !editable;

        return (
          <>
            <Margin bottom={1} css={styles.row}>
              <Text as="label" size={16}>
                Amount
              </Text>
              <div style={{ position: 'relative' }}>
                <FormInput
                  strictLong
                  name="amount"
                  placeholder="Amount"
                  css={styles.control}
                  disabled={disabled}
                />
              </div>
            </Margin>
            <Margin bottom={1} css={styles.row}>
              <Text as="label" size={16}>
                Currency
              </Text>
              <FormInput
                strictLong
                name="currency"
                placeholder="Currency"
                css={styles.control}
                disabled={disabled}
              />
            </Margin>
            <Margin bottom={1} css={styles.row}>
              <Text as="label" size={16}>
                Bank account
              </Text>
              <FormInput
                oldInput
                cacheOptions
                defaultOptions
                getOptionLabel={getOptionLabel}
                getOptionValue={getOptionValue}
                type="async-select"
                name="bankAccountName"
                placeholder="Select Bank Name"
                loadOptions={loadBankAccounts}
                styles={styles.select}
                disabled={disabled}
              />
            </Margin>
            <Margin bottom={1} css={styles.row}>
              <Text as="label" size={16}>
                Remarks
              </Text>
              <FormInput
                strictLong
                name="remarks"
                placeholder="Remarks"
                css={styles.control}
                disabled={disabled}
              />
            </Margin>
          </>
        )
      }}
    </EditableFormPanel>
  )
}

AddMemberInvoiceFormComponent.propTypes = {
  form: PropTypes.shape(),
  header: PropTypes.string.isRequired,
  onSubmitRequest: PropTypes.func,
  loadBankAccounts: PropTypes.func,
  setupAmountValidation: PropTypes.func,
}

export default AddMemberInvoiceFormComponent
